import Title from "../../atoms/Title";
import Sectiontitle from "../../molecules/Sectiontitle";
import Videosprojector from "../Homesections/Videossections/Videosprojector";
import { useTranslation } from "react-i18next";



export default function Charvideos({videos}) {
  const { t } = useTranslation();

  return (
    <div className=' h-full overflow-hidden bg-ed-400'>
             <Sectiontitle title={t("char.videos.title")} />

            <div className='h-full mx-[30px] pt-[25px] flex flex-col justify-start items-center'>
               <Videosprojector  videos={videos}/>
            </div>
    </div>
  )
}
